import React from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { Security } from "@okta/okta-react";
import { OktaAuth } from "@okta/okta-auth-js";
import oktaConfig from "./oktaConfig";
import Home from "./Home";
import Login from "./Login";
import RetailGID from "./RetailGID";
import SecureRoute from "./SecureRoute";
import NikeLoginCallback from "./NikeLoginCallback";
import GlobalLoadingOverlay from "./components/GlobalLoadingOverlay/GlobalLoadingOverlay";
import { StatusMessageProvider } from "./contexts/StatusMessageContext";
import { ApiActivityProvider } from "./contexts/ApiActivityContext";
import "./App.css";

const oktaAuth = new OktaAuth(oktaConfig);

const App = () => {
  const navigate = useNavigate();
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    navigate(originalUri || "/");
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <GlobalLoadingOverlay />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/callback" element={<NikeLoginCallback />} />
        <Route
          path="/"
          element={
            <SecureRoute>
              <StatusMessageProvider>
                <ApiActivityProvider>
                  <Home />
                </ApiActivityProvider>
              </StatusMessageProvider>
            </SecureRoute>
          }
        />
        <Route
          path="/RetailGIDManagement"
          element={
            <SecureRoute>
              <StatusMessageProvider>
                <ApiActivityProvider>
                  <RetailGID />
                </ApiActivityProvider>
              </StatusMessageProvider>
            </SecureRoute>
          }
        />
      </Routes>
    </Security>
  );
};

export default App;
